import { createContext, useContext, type ReactNode } from 'react'

interface TripsSheetContextValue {
  openTripsSheet: () => void
}

const TripsSheetContext = createContext<TripsSheetContextValue | null>(null)

export function TripsSheetProvider({
  children,
  openTripsSheet
}: {
  children: ReactNode
  openTripsSheet: () => void
}) {
  return (
    <TripsSheetContext.Provider value={{ openTripsSheet }}>
      {children}
    </TripsSheetContext.Provider>
  )
}

export function useTripsSheet(): TripsSheetContextValue | null {
  return useContext(TripsSheetContext)
}
